import { handleActions } from 'redux-actions';
import { ModalState } from './interfaces';
import Types from './types';

const initialState: ModalState = {
  modalDetails: null,
  modalState: null,
};

export default handleActions(
  {
    [Types.MODAL_OPEN]: (state: ModalState, { payload }) => ({
      ...state,
      modalDetails: { maxWidth: 'sm', ...payload },
      modalState: payload,
    }),
    [Types.MODAL_CLOSE]: (state: ModalState) => ({
      ...state,
      modalDetails: null,
    }),
  },
  initialState
);
